/**
 * Template — high-level visual layout family selected per session. Picks
 * which `templates/<name>` page tree renders. Theme tokens (palette,
 * overrides) are layered on top regardless of template.
 */
export type Template = 'classic' | 'modern' | 'sleek' | 'glass';
export const TEMPLATES: readonly Template[] = ['classic', 'modern', 'sleek', 'glass'] as const;
export const DEFAULT_TEMPLATE: Template = 'classic';

export type ThemeSource = 'backend' | 'url' | 'default';
